import * as EVENTS from '../../common/constant';
import { InsertHtml } from './inserthtml';
import { isNullOrUndefined as isNOU } from '@syncfusion/ej2-base';
import { cleanHTMLString } from './../../common/util';
export class AIAssistantActions {
    constructor(parent) {
        this.parent = parent;
        this.addEventListener();
    }
    addEventListener() {
        this.parent.observer.on(EVENTS.AI_ASSISTANT_ACTIONS, this.actionHandler, this);
        this.parent.observer.on(EVENTS.INTERNAL_DESTROY, this.destroy, this);
    }
    removeEventListener() {
        this.parent.observer.off(EVENTS.AI_ASSISTANT_ACTIONS, this.actionHandler);
        this.parent.observer.off(EVENTS.INTERNAL_DESTROY, this.destroy);
    }
    actionHandler(args) {
        const subCommand = args.subCommand;
        if (subCommand === 'InsertResponseContent') {
            this.parent.nodeSelection.restore();
            const currentRange = this.parent.nodeSelection.getRange(this.parent.currentDocument);
            const closestBlockElement = this.parent.domNode.blockNodes()[0];
            if (currentRange.collapsed && !isNOU(closestBlockElement) && closestBlockElement.textContent.length > 0) {
                currentRange.selectNodeContents(closestBlockElement);
            }
            InsertHtml.Insert(this.parent.currentDocument, args.value, this.parent.editableElement, true, args.enterAction, this.parent);
            this.callBack(args); // To trigger the actionComplete and then enable the undo redo.
        }
        else if (subCommand === 'ReplaceEditorContent') {
            this.parent.editableElement.innerHTML = cleanHTMLString(args.value, this.parent.editableElement);
            const firstPosition = this.parent.nodeSelection.findFirstContentNode(this.parent.editableElement);
            this.parent.nodeSelection.setCursorPoint(this.parent.currentDocument, firstPosition.node, 0);
            this.callBack(args);
        }
    }
    callBack(event) {
        event.callBack({
            requestType: event.command,
            action: event.subCommand,
            editorMode: 'HTML',
            range: this.parent.nodeSelection.getRange(this.parent.currentDocument),
            elements: this.parent.nodeSelection.getSelectedNodes(this.parent.currentDocument)
        });
    }
    destroy() {
        this.removeEventListener();
        this.parent = null;
    }
}
